"use strict";

const isServer = require("./is-server")();

const COOKIE_NAME = "premiumPicksLists";
const API_URL = "/v4/2023-rotating-catalog";
const DEFAULT_PREMIUM_PICKS_OBJECT = { current: [], next: [] };

// Fetch Premium Picks data
const fetchAndCachePremiumPicks = function(req, res) {
  const fetchError = "Failed to retrieve Premium Picks";

  return new Promise(resolve => {
    if (isServer) {
      const mod = module;
      const errors = mod.require("../server/errors");
      const api = mod.require("../server/utils/api-http");

      api
        .get(API_URL, null, res, req)
        .then(response => {
          resolve(setCachedPremiumPicks(response, res));
        })
        .catch(err => {
          errors.log(err, fetchError);
          resolve(DEFAULT_PREMIUM_PICKS_OBJECT);
        });
    } else {
      $.get(API_URL)
        .then(response => {
          resolve(setCachedPremiumPicks(response));
        })
        .catch(err => {
          console.error(err, fetchError);
          resolve(DEFAULT_PREMIUM_PICKS_OBJECT);
        });
    }
  });
};

// Get Premium Picks data
const getCachedPremiumPicks = function(req, res) {
  return new Promise(resolve => {
    let cookie;

    if (isServer) {
      cookie = req.cookies[COOKIE_NAME];
    } else {
      cookie = window?.wattpad?.utils.getCookie(COOKIE_NAME);
    }

    if (cookie) return resolve(cookie ? JSON.parse(cookie) : null);

    fetchAndCachePremiumPicks(req, res)
      .then(resolve)
      .catch(resolve);
  });
};

/**
 * Caches Premium Picks ids
 * (Temporary functionality for Rotating Catalog - Phase 1)
 * @returns {Object} Returns an object with an array of current and next story ids
 */
const setCachedPremiumPicks = function(premiumPicksResponse, res) {
  const current = premiumPicksResponse.current.stories.map(story => story.id);
  const next = premiumPicksResponse.next.stories.map(story => story.id);
  const premiumPicksObj = { current, next };
  const cookieValue = JSON.stringify(premiumPicksObj);
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 1);
  expiryDate.setHours(0, 0, 0, 0);

  if (isServer) {
    res.cookie(COOKIE_NAME, cookieValue, {
      path: "/",
      expires: expiryDate // Expire every 24 hours at 00:00:00
    });
  } else {
    window?.wattpad?.utils.setCookieWithExpiry(
      COOKIE_NAME,
      cookieValue,
      expiryDate
    );
  }

  return premiumPicksObj;
};

module.exports = {
  fetchAndCachePremiumPicks,
  getCachedPremiumPicks,
  setCachedPremiumPicks,
  DEFAULT_PREMIUM_PICKS_OBJECT
};
